import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, fmt, fmtDate, getUser, toUsd } from '../api';
import { Modal, Field, Input, useToast, Loading, Eyebrow, rowNav } from '../ui';
import { Icons } from '../icons';

const CUR: Record<string, string> = { CNY: '¥', USD: '$', UZS: "so'm" };

export default function Suppliers() {
  const [list, setList] = useState<any[] | null>(null);
  const [edit, setEdit] = useState<any>(null);
  const toast = useToast();
  const nav = useNavigate();
  const user = getUser();
  const canEdit = ['admin', 'zakaz_operator'].includes(user?.role);

  const load = () => api.get('/suppliers?withTotals=true').then(setList).catch((e) => { toast(e.message, true); setList([]); });
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (edit.id) await api.patch('/suppliers/' + edit.id, edit);
      else await api.post('/suppliers', edit);
      toast('Saqlandi'); setEdit(null); load();
    } catch (e: any) { toast(e.message, true); }
  };

  if (!list) return <Loading />;
  return (
    <div>
      <div className="page-head">
        <div><h1 className="page-title">Zavodlar</h1><p className="page-sub">{list.length} ta yetkazib beruvchi · qatorga bosing — akt sverka ochiladi</p></div>
        {canEdit && <button className="btn btn-primary" onClick={() => setEdit({ currency: 'CNY' })}>+ Yangi zavod</button>}
      </div>
      <div className="table-wrap">
        <table>
          <thead><tr>
            <th>Nomi</th><th className="num">Boshlang'ich saldo</th><th className="num">Zakaz</th><th>Oxirgi zakaz</th>
            <th className="num">Dona</th><th className="num">Kg</th>
            <th className="num">Qarzimiz (debet)</th><th className="num">To'langan</th><th className="num">Saldo</th><th></th>
          </tr></thead>
          <tbody>
            {list.map((s) => {
              const money = (o: any) => {
                if (!o || Object.keys(o).length === 0) return <span className="muted">—</span>;
                const txt = Object.entries(o).map(([c, v]) => `${fmt(v as number, 2)} ${CUR[c] || c}`).join(' + ');
                let usd = 0, ok = true;
                for (const [c, v] of Object.entries(o)) { const u = toUsd(v as number, c); if (u == null) { ok = false; break; } usd += u; }
                return (
                  <span>{txt}
                    {ok && usd > 0 && <div className="muted" style={{ fontSize: 11.5, fontWeight: 400 }}>≈ ${fmt(usd, 0)}</div>}
                  </span>
                );
              };
              const owes = Object.values(s.balance || {}).some((v: any) => v > 0.01);
              return (
              <tr key={s.id} style={{ cursor: 'pointer' }} onClick={rowNav(() => nav('/payments?supplierId=' + s.id))}>
                <td style={{ fontWeight: 600 }}>{s.name}</td>
                <td className="num">
                  {s.openingBalance == null || Number(s.openingBalance) === 0
                    ? <span className="muted">—</span>
                    : Number(s.openingBalance) > 0
                      ? <span className="down">{fmt(s.openingBalance, 2)} {CUR[s.openingCurrency] || s.openingCurrency}</span>
                      : <span className="up">avans {fmt(Math.abs(Number(s.openingBalance)), 2)} {CUR[s.openingCurrency] || s.openingCurrency}</span>}
                </td>
                <td className="num">{s.orders ?? 0}</td>
                <td>{s.lastOrderDate ? fmtDate(s.lastOrderDate) : '—'}</td>
                <td className="num">{s.units ? fmt(s.units) : '—'}</td>
                <td className="num">{s.kg ? fmt(s.kg, 1) : '—'}</td>
                <td className="num">{money(s.debit)}</td>
                <td className="num">{money(s.credit)}</td>
                <td className="num" style={{ fontWeight: 700 }}>
                  <span className={owes ? 'down' : ''}>{money(s.balance)}</span>
                </td>
                <td onClick={(e) => e.stopPropagation()}>
                  <div className="act-row">
                    <button className="act act-view" title="Akt sverka" onClick={() => nav('/payments?supplierId=' + s.id)}><Icons.receipt size={15} /></button>
                    {canEdit && <button className="act act-edit" title="Tahrirlash" onClick={() => setEdit({ ...s })}><Icons.edit size={16} /></button>}
                  </div>
                </td>
              </tr>
            );})}
          </tbody>
        </table>
      </div>
      {edit && (
        <Modal title={edit.id ? 'Zavodni tahrirlash' : 'Yangi zavod'} onClose={() => setEdit(null)}>
          <div className="grid-2">
            <Field label="Nomi *"><Input value={edit.name || ''} onChange={(e) => setEdit({ ...edit, name: e.target.value })} /></Field>
            <Field label="Mamlakat"><Input value={edit.country || ''} onChange={(e) => setEdit({ ...edit, country: e.target.value })} /></Field>
            <Field label="Aloqa (WeChat/tel)"><Input value={edit.contact || ''} onChange={(e) => setEdit({ ...edit, contact: e.target.value })} /></Field>
            <Field label="Valyuta"><Input value={edit.currency || 'CNY'} onChange={(e) => setEdit({ ...edit, currency: e.target.value })} /></Field>
          </div>
          <Eyebrow title="Boshlang'ich saldo" desc="buxgalteriyadan (1C) ko'chirilgan hozirgi holat" />
          <p className="muted" style={{ fontSize: 12.5, marginTop: -6 }}>
            <b>Musbat</b> = biz zavodga qarzdormiz · <b>Manfiy</b> = avans berganmiz.
            Sanadan oldingi zakaz va to'lovlar hisobga olinmaydi — ular shu raqam ichida.
          </p>
          <div className="grid-3">
            <Field label="Saldo">
              <Input type="number" step="0.01" value={edit.openingBalance ?? ''}
                onChange={(e) => setEdit({ ...edit, openingBalance: e.target.value })} />
            </Field>
            <Field label="Valyutasi">
              <Input value={edit.openingCurrency || 'CNY'} onChange={(e) => setEdit({ ...edit, openingCurrency: e.target.value })} />
            </Field>
            <Field label="Qaysi sanaga">
              <Input type="date" value={edit.openingDate ? String(edit.openingDate).slice(0, 10) : ''}
                onChange={(e) => setEdit({ ...edit, openingDate: e.target.value })} />
            </Field>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <button className="btn" onClick={() => setEdit(null)}>Bekor</button>
            <button className="btn btn-primary" onClick={save}>Saqlash</button>
          </div>
        </Modal>
      )}
    </div>
  );
}
